"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_ADAPTABLE_COLUMN_MENU_ORDER = exports.DEFAULT_ADAPTABLE_CONTEXT_MENU_ORDER = void 0;
const tslib_1 = require("tslib");
const ModuleConstants = tslib_1.__importStar(require("../Utilities/Constants/ModuleConstants"));
exports.DEFAULT_ADAPTABLE_CONTEXT_MENU_ORDER = [
    ModuleConstants.SettingsPanelModuleId,
    ModuleConstants.DashboardModuleId,
    ModuleConstants.ToolPanelModuleId,
    ModuleConstants.StatusBarModuleId,
    ModuleConstants.LayoutModuleId,
    ModuleConstants.FormatColumnModuleId,
    ModuleConstants.StyledColumnModuleId,
    ModuleConstants.FlashingCellModuleId,
    ModuleConstants.CustomSortModuleId,
    ModuleConstants.CellSummaryModuleId,
    ModuleConstants.Fdc3ModuleId,
    ModuleConstants.GridInfoModuleId,
    ModuleConstants.ColumnInfoModuleId,
    ModuleConstants.AlertModuleId,
    ModuleConstants.CalculatedColumnModuleId,
    ModuleConstants.ExportModuleId,
    ModuleConstants.ColumnFilterModuleId,
    ModuleConstants.SmartEditModuleId,
    ModuleConstants.BulkUpdateModuleId,
    ModuleConstants.TeamSharingModuleId,
    ModuleConstants.DataChangeHistoryModuleId,
    ModuleConstants.DataSetModuleId,
    ModuleConstants.FreeTextColumnModuleId,
    ModuleConstants.NamedQueryModuleId,
    ModuleConstants.QuickSearchModuleId,
    ModuleConstants.DataSetModuleId,
    ModuleConstants.AlertModuleId,
    ModuleConstants.SystemStatusModuleId,
    ModuleConstants.CalculatedColumnModuleId,
    ModuleConstants.FreeTextColumnModuleId,
    ModuleConstants.ExportModuleId,
    ModuleConstants.DataImportModuleId,
    ModuleConstants.DataChangeHistoryModuleId,
    ModuleConstants.SmartEditModuleId,
    ModuleConstants.PlusMinusModuleId,
    ModuleConstants.BulkUpdateModuleId,
    ModuleConstants.ShortcutModuleId,
    ModuleConstants.TeamSharingModuleId,
    ModuleConstants.ScheduleModuleId,
    ModuleConstants.StateManagementModuleId,
    ModuleConstants.ThemeModuleId,
    ModuleConstants.ChartingModuleId,
    ModuleConstants.NotesModuleId,
];
exports.DEFAULT_ADAPTABLE_COLUMN_MENU_ORDER = [
    ModuleConstants.SettingsPanelModuleId,
    ModuleConstants.DashboardModuleId,
    ModuleConstants.ToolPanelModuleId,
    ModuleConstants.StatusBarModuleId,
    ModuleConstants.LayoutModuleId,
    ModuleConstants.FormatColumnModuleId,
    ModuleConstants.StyledColumnModuleId,
    ModuleConstants.FlashingCellModuleId,
    ModuleConstants.CustomSortModuleId,
    ModuleConstants.CellSummaryModuleId,
    ModuleConstants.Fdc3ModuleId,
    ModuleConstants.GridInfoModuleId,
    ModuleConstants.ColumnInfoModuleId,
    ModuleConstants.AlertModuleId,
    ModuleConstants.CalculatedColumnModuleId,
    ModuleConstants.ExportModuleId,
    ModuleConstants.ColumnFilterModuleId,
    ModuleConstants.SmartEditModuleId,
    ModuleConstants.BulkUpdateModuleId,
    ModuleConstants.TeamSharingModuleId,
    ModuleConstants.DataChangeHistoryModuleId,
    ModuleConstants.DataSetModuleId,
    ModuleConstants.FreeTextColumnModuleId,
    ModuleConstants.NamedQueryModuleId,
    ModuleConstants.QuickSearchModuleId,
    ModuleConstants.DataSetModuleId,
    ModuleConstants.AlertModuleId,
    ModuleConstants.SystemStatusModuleId,
    ModuleConstants.CalculatedColumnModuleId,
    ModuleConstants.FreeTextColumnModuleId,
    ModuleConstants.ExportModuleId,
    ModuleConstants.DataImportModuleId,
    ModuleConstants.DataChangeHistoryModuleId,
    ModuleConstants.SmartEditModuleId,
    ModuleConstants.PlusMinusModuleId,
    ModuleConstants.BulkUpdateModuleId,
    ModuleConstants.ShortcutModuleId,
    ModuleConstants.TeamSharingModuleId,
    ModuleConstants.ScheduleModuleId,
    ModuleConstants.StateManagementModuleId,
    ModuleConstants.ThemeModuleId,
    ModuleConstants.ChartingModuleId,
    ModuleConstants.NotesModuleId,
];
